import { render, staticRenderFns } from "./SidebarMain.vue?vue&type=template&id=cbe426ca&scoped=true"
import script from "./SidebarMain.vue?vue&type=script&lang=ts"
export * from "./SidebarMain.vue?vue&type=script&lang=ts"
import style0 from "./SidebarMain.vue?vue&type=style&index=0&id=cbe426ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe426ca",
  null
  
)

export default component.exports